<template>
  <el-row style="margin: 10px">
    <el-col :span="4" style="height: 100%">
      <div style="text-align: center; padding: 0px 0px 10px 0px">
        <h4>协议方法</h4>
      </div>
      <aside
        style="
          height: 100%;
          overflow: hidden;
          border-right: solid 1px #e6e6e6;
          background-color: #e6e6e6;
        "
      >
        <el-menu
          class="el-menu-vertical-demo"
          style="border: 0px; background-color: rgb(221 221 221 / 10%)"
        >
          <el-menu-item
            v-for="(item, index) in methodList"
            :index="index + ''"
            :key="item.id"
            @click="showDevice(item)"
          >
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
        </el-menu>
      </aside>
    </el-col>
    <el-col :span="20" style="padding: 0px 10px">
      <el-row class="warp">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :inline="true" :model="searchForm">
            <el-form-item label="设备号：">
              <el-input
                v-model="searchForm.deviceCode"
                placeholder="设备号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备型号">
              <el-input
                v-model="searchForm.deviceSn"
                placeholder="设备型号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备品类：">
              <el-select
                v-model="searchForm.deviceCategoryId"
                placeholder="设备品类"
                clearable
                style="width: 320px"
              >
                <el-option
                  v-for="(item, index) in deviceCategoryDatas"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备供应商">
              <el-select
                v-model="searchForm.supplierId"
                placeholder="设备供应商"
                clearable
                style="width: 320px"
              >
                <el-option
                  v-for="(item, index) in allSupplier"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目">
              <el-select
                v-model="searchForm.projectId"
                placeholder="项目"
                clearable
                style="width: 350px"
              >
                <el-option
                  v-for="(item, index) in projectSelects"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="showDevice('')"
                >查询</el-button
              >
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="resetForm()"
                >重置</el-button
              >
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="bindDevice"
                >添加设备</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
        <el-col
          :span="24"
          v-loading="loading"
          element-loading-text="拼命加载中"
        >
          <!--列表-->
          <el-table :data="deviceList" highlight-current-row border lazy>
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="60"
              fixed="left"
            ></el-table-column>
            <el-table-column
              prop="deviceCode"
              label="设备编号"
              align="center"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="deviceShortcode"
              label="设备短号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="deviceSn"
              label="设备型号"
              align="center"
              width="220"
            ></el-table-column>
            <el-table-column
              prop="deviceSupplierCategoryName"
              label="设备类别"
              align="center"
              width="280"
            ></el-table-column>
            <el-table-column
              prop="deviceSupplierName"
              label="供应商"
              align="center"
              width="280"
            ></el-table-column>
            <el-table-column
              prop="projectName"
              label="项目"
              align="center"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="deviceState"
              label="设备状态"
              align="center"
              width="160"
            ></el-table-column>

            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="260"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  style="margin: 0; padding: 5px"
                  @click="remove(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              style="float: right"
            >
            </el-pagination>
          </el-col>
        </el-col>
      </el-row>
    </el-col>

    <el-dialog
      :title="bind.title"
      :visible.sync="bind.visible"
      :close-on-click-modal="false"
      width="80%"
      top="5vh"
    >
      <el-row>
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :model="bind.searchForm" :inline="true">
            <el-form-item label="设备号：">
              <el-input
                v-model="bind.searchForm.deviceCode"
                placeholder="设备号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备型号">
              <el-input
                v-model="bind.searchForm.deviceSn"
                placeholder="设备型号"
                maxlength="50"
                style="width: 320px"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备品类：">
              <el-select
                v-model="bind.searchForm.deviceCategoryId"
                placeholder="设备品类"
                clearable
                style="width: 320px"
              >
                <el-option
                  v-for="(item, index) in deviceCategoryDatas"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备供应商">
              <el-select
                v-model="bind.searchForm.supplierId"
                placeholder="设备供应商"
                clearable
                style="width: 320px"
              >
                <el-option
                  v-for="(item, index) in allSupplier"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目">
              <el-select
                v-model="bind.searchForm.projectId"
                placeholder="项目"
                clearable
                style="width: 350px"
              >
                <el-option
                  v-for="(item, index) in projectSelects"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="bindSearch"
                >查询</el-button
              >
              <el-button
                type="primary"
                style="margin: 5px 0px 5px 5px; padding: 5px; font-size: 12px"
                @click="noBindResetForm()"
                >重置</el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="bind.tableList"
            highlight-current-row
            border
            lazy
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :row-key="rowkey"
          >
            <el-table-column
              type="selection"
              width="55"
              :reserve-selection="true"
            ></el-table-column>
            <el-table-column
              prop="deviceName"
              label="设备名称"
              align="center"
              fixed="left"
            ></el-table-column>
            <el-table-column
              prop="deviceCode"
              label="设备编号"
              align="center"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="deviceShortcode"
              label="设备短号"
              align="center"
              width="180"
            ></el-table-column>
            <el-table-column
              prop="deviceSn"
              label="设备型号"
              align="center"
              width="220"
            ></el-table-column>
            <el-table-column
              prop="deviceSupplierCategoryName"
              label="设备类别"
              align="center"
              width="280"
            ></el-table-column>
            <el-table-column
              prop="deviceSupplierName"
              label="供应商"
              align="center"
              width="280"
            ></el-table-column>
            <el-table-column
              prop="projectName"
              label="项目"
              align="center"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="deviceState"
              label="设备状态"
              align="center"
              width="160"
            ></el-table-column>
          </el-table>
          <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-pagination
              @size-change="bindhandleSizeChange"
              @current-change="bindhandleCurrentChange"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="10"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="bind.total"
              style="float: right"
            >
            </el-pagination>
          </el-col>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="bind.visible = false">取消</el-button>
        <el-button type="primary" @click.native="bind.submit" :loading="loading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </el-row>
</template>
<script>
import API from "../../api/blue/api_device";
import PROJECT_API from "../../api/api_project";
import DEVICE_API from "../../api/api_device";
export default {
  data() {
    return {
      loading: false,
      methodList: [
        { name: "方法1", index: 1, code: 1 },
        { name: "方法2", index: 2, code: 2 },
        { name: "方法3", index: 3, code: 3 },
        { name: "方法4", index: 4, code: 4 },
        { name: "方法5", index: 5, code: 5 },
        { name: "方法6", index: 6, code: 6 },
        { name: "方法7", index: 7, code: 7 },
        { name: "方法8", index: 8, code: 8 },
        { name: "方法9", index: 9, code: 9 },
        { name: "方法10", index: 10, code: 10 },
        { name: "方法11", index: 11, code: 11 },
        { name: "方法12", index: 12, code: 12 }
      ],
      deviceList: [],
      searchForm: {},
      deviceCategoryDatas: [],
      deviceSupplierCategoryDatas: [],
      projectSelects: [],
      allSupplier: [],
      selectPlatform: null,
      selectInter: null,
      total: 0,
      page: 1,
      limit: 10,
      bind: {
        title: "绑定新设备",
        visible: false,
        total: 0,
        page: 1,
        limit: 10,
        data: {},
        tableList: [],
        dictList: [],
        selectDevice: [],
        submit: function () {},
        systemId: null,
        bigId: null,
        typeId: null,
        bigList: [],
        typeList: [],
        searchForm: {} //搜索条件
      }
    };
  },
  methods: {
    resetForm: function () {
      this.searchForm = {};
      this.showDevice();
    },
    noBindResetForm() {
      this.bind.searchForm = {};
      this.bindSearch();
    },
    getMyProject: function (query, callback) {
      let that = this;
      PROJECT_API.getMyProject({ projectName: query ? query : "" })
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.projectSelects = result.data;
              if (callback) {
                callback();
              }
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常!",
            duration: 2000
          });
        });
    },
    supplierSelect: function () {
      let that = this;
      DEVICE_API.allSupplier({})
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.allSupplier = result.data;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    deviceCategoryCombox: function () {
      let that = this;
      DEVICE_API.deviceCategoryCombox({})
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.deviceCategoryDatas = result.data;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常!",
            duration: 2000
          });
        });
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleSizeChange(val) {
      this.limit = val;
      this.showDevice();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.showDevice();
    },
    search() {
      let that = this;
    },
    showDevice(row) {
      let that = this;
      that.selectPlatform = that.selectPlatform || (row ? row.platformId : "");
      that.selectInter = row ? row.code : that.selectInter;
      console.log(that.selectInter);
      if (!that.selectInter) {
        that.$message.error({
          showClose: true,
          message: "请选择平台下接口",
          duration: 2000
        });
        return;
      }
      that.loading = true;
      let params = this.searchForm;
      params.page = that.page;
      params.limit = that.limit;
      params.methodCode = that.selectInter;
      API.list(params)
        .then(
          function (result) {
            that.loading = false;
            console.log(result);
            if (result && result.code == 200) {
              that.total = result.data.total;
              that.deviceList = result.data.records;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    bindDevice() {
      let that = this;
      that.bind.systemId = null;
      that.bind.bigId = null;
      that.bind.typeId = null;
      that.bind.tableList = [];
      that.$nextTick(() => {
        that.$refs.multipleTable.clearSelection();
      });

      if (that.selectInter == null) {
        that.$message.error({
          showClose: true,
          message: "请选择平台下接口",
          duration: 2000
        });
        return;
      }
      that.bind.visible = true;
      that.bind.searchForm = {};
      that.bindSearch();
    },
    bindSearch() {
      let that = this;
      let params = that.bind.searchForm;
      params.page = that.bind.page;
      params.limit = that.bind.limit;
      params.methodCode = that.selectInter;
      API.noBingList(params)
        .then(
          function (result) {
            that.loading = false;
            console.log(result);
            if (result && result.code == 200) {
              that.bind.total = result.data.total;
              that.bind.tableList = result.data.records;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });

      //提交
      that.bind.submit = function () {
        let deviceIds = that.bind.selectDevice.map((s) => {
          return s.id;
        });

        let parms = deviceIds;
        console.log(parms);
        API.addDevice(that.selectInter, parms)
          .then(
            function (result) {
              if (result && result.code == 200) {
                that.bind.visible = false;
                that.showDevice();
              }
            },
            function (err) {
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function (error) {
            console.log(error);
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
      };
    },
    handleSelectionChange: function (val) {
      this.bind.selectDevice = val;
    },
    rowkey: function (row) {
      return row.deviceId;
    },
    bindhandleSizeChange(val) {
      this.bind.limit = val;
      this.bindSearch();
    },
    bindhandleCurrentChange(val) {
      this.bind.page = val;
      this.bindSearch();
    },
    systemChange(val) {
      console.log(val);
      let system = this.bind.dictList.find((s) => s.dictId == val);
      if (system && system.child) {
        this.bind.bigList = system.child;
      }
    },
    bigChange(val) {
      console.log(val);
      let big = this.bind.bigList.find((s) => s.dictId == val);
      if (big && big.child) {
        this.bind.typeList = big.child;
      }
    },
    remove(index, row) {
      console.log(row);
      let that = this;
      this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        .then(() => {
          that.loading = true;
          API.delete(row.blueId)
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code === 200) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500
                  });
                  that.showDevice();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.msg,
                    duration: 1500
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    //消防平台上报数据
    selfReport(index, row) {}
  },
  mounted() {
    this.supplierSelect();
    this.deviceCategoryCombox();
    this.getMyProject();
    this.search();
  }
};
</script>
<style scoped>
.el-menu-item.is-active {
  background-color: rgb(71, 71, 230);
}
</style>



// WEBPACK FOOTER //
// deviceBlue.vue?2ce2f116